import { render, staticRenderFns } from "./ScreenFacturador.vue?vue&type=template&id=8520b634"
import script from "./ScreenFacturador.vue?vue&type=script&lang=js"
export * from "./ScreenFacturador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports